module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.nl2br(_vm.question.content))
    }
  }), _vm._v(" "), (!_vm.question.answered) ? _c('div', [_c('b-input-group', {
    staticClass: "col-12 col-sm-10 offset-sm-2 col-md-8 offset-md-4 col-lg-6 offset-lg-6 mb-2"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Lösung..."
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submitAnswer()
      }
    },
    model: {
      value: (_vm.question.userAnswer),
      callback: function($$v) {
        _vm.question.userAnswer = $$v
      },
      expression: "question.userAnswer"
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    attrs: {
      "variant": 'success'
    },
    on: {
      "click": function($event) {
        _vm.submitAnswer()
      }
    }
  }, [_vm._v("lösen")])], 1)], 1), _vm._v(" "), _vm._l((_vm.question.tryings), function(tried, tey) {
    return _c('b-alert', {
      key: tey,
      attrs: {
        "variant": tried.type,
        "show": "",
        "dismissible": true
      }
    }, [_c('strong', [_vm._v(_vm._s(tried.answer))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.nl2br(tried.message))
      }
    })])
  })], 2) : _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "badge badge-info"
  }, [_vm._v(_vm._s(_vm.question.answer) + " "), _c('i', {
    staticClass: "fa fa-check fa-fw"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ae77114"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/questions/one/One.vue
// module id = 706
// module chunks = 1